export default __webpack_public_path__ + "img/8d245e724157797234b0e3a725b2e6c5.png";